import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private http: HttpClient) {}
  baseUrl: string | undefined = 'https://zumera-backend.onrender.com';
 
  postSubscriber(form: {
    name: string,
    email: string
  }){

    return this.http.post(
      `https://zumera-backend.onrender.com/subscriber`,
      {
       name: form.name,
       email: form.email
      },
    );
  }

  postApplicant(formData: FormData){
    const headers = new HttpHeaders().set('Content-Type', 'multipart/form-data');

    return this.http.post(
      `${this.baseUrl}/apply`,
      formData, {
        headers,
        reportProgress: true,
        observe: 'events'
      }
    );
  }
}